import { notification } from "ui/Notification"

export const validateFile = (file, t, notifyError = true) => {
  const fileName = file.name.toLowerCase()
  const fileType = file.type
  const fileSize = file.size

  const isVideo = isValidVideo(fileType, fileName)
  const isImage = isValidImage(fileType, fileName)

  if (!isImage && !isVideo) {
    showError("unsupported", t, notifyError)
    return { isValid: false, type: null }
  }

  const maxSize = getMaxSize(isImage, isVideo)
  if (fileSize > maxSize) {
    const errorKey = isImage ? "imageTooLarge" : "videoTooLarge"
    showError(errorKey, t, notifyError)
    return { isValid: false, type: null }
  }

  return { isValid: true, type: isImage ? "image" : "video" }
}

const isValidImage = (fileType, fileName) => fileType.startsWith("image/") && /\.(jpg|jpeg|png|webp)$/.test(fileName)

const isValidVideo = (fileType, fileName) => fileType.startsWith("video/") && /\.(mp4|mov|webm)$/.test(fileName)

const getMaxSize = (isImage, isVideo) => {
  if (isImage) return 10 * 1024 * 1024
  if (isVideo) return 25 * 1024 * 1024
  return 0
}

const showError = (key, t, notifyError) => {
  if (!notifyError || !t) return
  notification.error({ message: t(`messenger.errors.${key}`) })
}
